var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M2.62 8.333a7.381 7.381 0 0 1 14.761 0c0 2.068-.938 3.887-2.232 5.567-1.081 1.405-2.466 2.777-3.855 4.155q-.396.39-.789.784a.714.714 0 0 1-1.01 0q-.392-.393-.788-.784c-1.39-1.378-2.775-2.75-3.856-4.155-1.294-1.68-2.232-3.5-2.232-5.567m7.38 2.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5",
  clipRule: "evenodd"
})));
SvgPin.displayName = "SvgPin";
export { SvgPin as ReactComponent };
export default SvgPin;